const trendsEN = {
    "view": {
        "form": {
            "label": {
                "filters": "Filters",
                "period": "Period",
                "store": "Store",
                "label": "Label",
                "release": "Release",
                "track": "Track",
                "subuser": "Subuser",
                "fetchingTrends": "Fetching trends from database",
            },
            "button": {
                "resetFilters": "Reset Filters",
            },
            "options": {
                "store": {
                    "allStores": "All Stores",
                    "downloadStores": "Download Stores",
                    "streamingStores": "Streaming Stores",
                    "streamStores": "Stream Stores",
                },
                "label": {
                    "allLabels": "All Labels",
                },
                "release": {
                    "allReleases": "All Releases",
                },
                "track": {
                    "allTracks": "All Tracks",
                },
                "subuser": {
                    "selectSubuser": "Select Subuser",
                },
                "period": {
                    "last7Days": "Last 7 Days",
                    "last14Days": "Last 14 Days",
                    "last30Days": "Last 30 Days",
                    "last45Days": "Last 45 Days",
                    "last60Days": "Last 60 Days",
                    "last75Days": "Last 75 Days",
                    "last90Days": "Last 90 Days"
                }
            }
        },
        "top10": {
            "title": "Top 10",
            "table": {
                "column": {
                    "artistName": "Artist",
                    "songMixName": "Song/Mix Name",
                    "numberOfSales": "Number Of Sales",
                },
            }
        },
        "storeWiseSales": {
            "title": "Store-wise Sales",
            "label": {
                "amazonMusicStream": "Amazon Music stream",
                "appleMusicStream": "Apple Music stream",
                "beatportStream": "Beatport stream",
                "deezerStream": "Deezer stream",
                "facebookStream": "Facebook stream",
                "instagramStream": "Instagram stream",
                "itunesDownload": "iTunes download",
                "pandoraStream": "Pandora stream",
                "soundcloudStream": "SoundCloud stream",
                "spotifyStream": "Spotify stream",
                "tiktokStream": "Tiktok stream",
                "traxsourceStream": "Traxsource stream",
                "youtubeStream": "Youtube stream",
                "youtubePremiumStream": "Youtube Premium stream",
                "totalSales": "Total sales",
                "storeMessage": "* Store labels are ordered alphabetically (A-Z)",
            }
        },
        "salesByTerritory": {
            "title": "Sales By Territory",
        },
        "salesByGender": {
            "title": "Sales By Gender",
            "label": {
                "male": "Male",
                "female": "Female",
                "nonBinary": "Non-binary",
                "unknown": "Unknown",
            },
        },
        "salesByAge": {
            "title": "Sales By Age",
            "label": {
                "male": "Male",
                "female": "Female",
                "genderOther": "Non-binary",
                "unknown": "Unknown",
                "ageWiseSales": "Age Wise Sales",
                "ageUnknown": "Age Unknown",
            },
        },
        "message": {
            "noAccess": "You don't have access to this module, please contact the support team for further information.",
            "subscriptionExpired": "Your subscription has expired. Please <1>resume</1> your subscription to avail this feature.",
            "subscriptionUpgrade": "Your current subscription plan does not support this feature. Please <1>upgrade</1> your subscription plan to avail this feature.",
        }
    }
};

export default trendsEN;